import { styled } from 'styled-components';

import type { ApiRequestedAttachmentAcknowledgement } from '#/api/types/ApiRequestedAttachment';
import { Checkbox } from '#/components/Checkbox/Checkbox';
import { Field } from '#/components/Form/Field/Field';
import { RichText } from '#/components/Text/RichText';

const RequestedAcknowledgementFieldRichText = styled(RichText)`
  /* Increase priority */
  && {
    margin-top: -5px;

    p {
      line-height: 1.4;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }
`;

type Props = {
  requestedAttachment: ApiRequestedAttachmentAcknowledgement;
  name: string;
  disabled: boolean;
};

export function RequestedAcknowledgementField({
  requestedAttachment,
  name,
  disabled,
}: Props) {
  return (
    <Field
      inputProps={{ disabled }}
      name={name}
      renderInput={({ value, id, qaId, hasError, updateValue }) => {
        const checked = value
          ? (value as { acknowledged: boolean }).acknowledged
          : false;

        return (
          <Checkbox
            id={id}
            name={name}
            label={
              <RequestedAcknowledgementFieldRichText
                $noMargin
                dangerouslySetInnerHTML={{ __html: requestedAttachment.label }}
              />
            }
            checked={checked}
            hasError={hasError}
            onChange={(acknowledged) => {
              updateValue({
                type: 'ACKNOWLEDGEMENT',
                acknowledged,
              });
            }}
            data-qa-id={qaId}
            disabled={disabled}
          />
        );
      }}
    />
  );
}
